import { useServices } from 'containers/services';
import type { GetMeterModulesArg, GetMeterModulesResponse } from 'lib/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useMeterModules = (
  filter: GetMeterModulesArg['filter'] = {},
  options?: UseQueryOptions<GetMeterModulesResponse>,
): UseQueryResult<GetMeterModulesResponse> => {
  const { meterModulesApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterModules.filter(filter),
    queryFn: async ({ signal }) => await meterModulesApiClient.find({ filter, signal }),
    ...options,
  });
};
